import { computed } from "@preact/signals";
import {
  projectOrders,
  orderTotalCents,
  orderPaidCents,
  formatMoney,
  cents,
  type Order,
  type OrderStatus,
} from "@orderman/shared";
import { adminEvents } from "../../state/adminData.js";

// Bestellungen: alle Bestellungen der Veranstaltung (nicht nur „Meine Bons"), aus der geteilten
// Projektion. Reine Anzeige.

const STATUS: Record<OrderStatus, string> = {
  open: "offen",
  sent: "gesendet",
  paid: "bezahlt",
  void: "storniert",
};

const orders = computed<Order[]>(() =>
  adminEvents.value
    ? projectOrders(adminEvents.value)
        .filter((o) => o.status !== "void" && o.lines.some((l) => l.status !== "voided"))
        .sort((a, b) => b.openedAtMs - a.openedAtMs)
    : [],
);

export function OrdersView() {
  const list = orders.value;
  if (list.length === 0) return <div class="admin-empty">Noch keine Bestellungen.</div>;

  return (
    <div class="admin-scroll">
      {list.map((o) => {
        const active = o.lines.filter((l) => l.status !== "voided");
        const total = Number(orderTotalCents(o));
        const paid = Number(orderPaidCents(o));
        const qty = active.reduce((s, l) => s + l.qty, 0);
        return (
          <div key={o.id} class="ord-card">
            <div class="ord-head">
              <span class="ord-nr">{o.seqNo ? `#${o.seqNo}` : "—"}</span>
              <span class="ord-table">Tisch {String(o.tableRef)}</span>
              <span class={`ord-status st-${o.status}`}>{STATUS[o.status]}</span>
              <span class="ord-total">{formatMoney(cents(total))}</span>
            </div>
            <div class="ord-lines">
              {active.map((l) => (
                <div key={l.id as string} class="ord-line">
                  <span class="ord-line-qty">{l.qty}×</span>
                  <span class="ord-line-name">{l.name}</span>
                </div>
              ))}
            </div>
            <div class="ord-foot">
              <span>{qty} Pos.</span>
              {paid > 0 && paid < total && <span>· {formatMoney(cents(paid))} bezahlt</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
